<div class="individual-modal-container">
  <div class='individual-modal-close' (click)='close()'>
    <svg xmlns="http://www.w3.org/2000/svg" width='16' height='16'
         viewBox="0 0 16 16">
      <defs>
        <style>.cls-close-1{fill: #989fa5;}.cls-close-2 {fill: none;}</style>
      </defs>
      <g>
        <g>
          <rect class="cls-close-1" x="4" y="4" width="1" height="1"/>
          <rect class="cls-close-1" x="3" y="3" width="1" height="1"/>
          <rect class="cls-close-1" x="5" y="5" width="1" height="1"/>
          <rect class="cls-close-1" x="6" y="6" width="1" height="1"/>
          <rect class="cls-close-1" x="7" y="7" width="1" height="1"/>
          <rect class="cls-close-1" x="7" y="7" width="1" height="1"/>
          <rect class="cls-close-1" x="8" y="8" width="1" height="1"/>
          <rect class="cls-close-1" x="9" y="9" width="1" height="1"/>
          <rect class="cls-close-1" x="10" y="10" width="1" height="1"/>
          <rect class="cls-close-1" x="11" y="11" width="1" height="1"/>
          <rect class="cls-close-1" x="12" y="12" width="1" height="1"/>
          <rect class="cls-close-1" x="4" y="11" width="1" height="1"
                transform="translate(-7 16) rotate(-90)"/>
          <rect class="cls-close-1" x="3" y="12" width="1" height="1"
                transform="translate(-9 16) rotate(-90)"/>
          <rect class="cls-close-1" x="5" y="10" width="1" height="1"
                transform="translate(-5 16) rotate(-90)"/>
          <rect class="cls-close-1" x="6" y="9" width="1" height="1"
                transform="translate(-3 16) rotate(-90)"/>
          <rect class="cls-close-1" x="7" y="8" width="1" height="1"
                transform="translate(-1 16) rotate(-90)"/>
          <rect class="cls-close-1" x="7" y="8" width="1" height="1"
                transform="translate(-1 16) rotate(-90)"/>
          <rect class="cls-close-1" x="8" y="7" width="1" height="1"
                transform="translate(1 16) rotate(-90)"/>
          <rect class="cls-close-1" x="9" y="6" width="1" height="1"
                transform="translate(3 16) rotate(-90)"/>
          <rect class="cls-close-1" x="10" y="5" width="1" height="1"
                transform="translate(5 16) rotate(-90)"/>
          <rect class="cls-close-1" x="11" y="4" width="1" height="1"
                transform="translate(7 16) rotate(-90)"/>
          <rect class="cls-close-1" x="12" y="3" width="1" height="1"
                transform="translate(9 16) rotate(-90)"/>
          <rect class="cls-close-2" width="16" height="16"/>
        </g>
      </g>
    </svg>
  </div>
  <div class="individual-modal-header">Содержание</div>
  <div class="individual-modal-content">
    <div class="flex">
      <div class="modal-bg-dark flex-fill">
        <div class="individual-content-header">
          Показывать в таблице
        </div>
        <div class="individual-selected-table-rows">
          <div *ngFor='let row of selectedTableRows; let idx = index;'
               class='flex individual-selected-table-rows--item'>
            <div
              class='flex-fill individual-selected-table-rows--text'>{{getRowName(row)}}
            </div>
            <a class='individual-selected-table-rows--cmd arrow-up-down'
               href='javascript:;' (click)='moveUp(idx)'>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <defs><style>.cls-arrow-up-1{fill:none;}.cls-arrow-up-2{fill:#495660;}</style></defs>
                <g id="Слой_2" data-name="Слой 2"><g id="Слой_10" data-name="Слой 10">
                  <rect class="cls-arrow-up-1" width="16" height="16"/>
                  <rect class="cls-arrow-up-2" x="8.99" y="2" width="1" height="10"/>
                  <rect class="cls-arrow-up-2" x="10" y="3" width="1" height="1"/>
                  <rect class="cls-arrow-up-2" x="11" y="4" width="1" height="1"/>
                  <rect class="cls-arrow-up-2" x="12" y="5" width="1" height="1"/>
                  <rect class="cls-arrow-up-2" x="8" y="3" width="1" height="1" transform="translate(17 7) rotate(-180)"/>
                  <rect class="cls-arrow-up-2" x="7" y="4" width="1" height="1" transform="translate(15 9) rotate(-180)"/>
                  <rect class="cls-arrow-up-2" x="6" y="5" width="1" height="1" transform="translate(13 11) rotate(-180)"/>
                </g></g>
              </svg>
            </a>
            <a class='individual-selected-table-rows--cmd arrow-up-down'
               href='javascript:;' (click)='moveDown(idx)'>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <defs><style>.cls-arrow-down-1{fill:#495660;}.cls-arrow-down-2{fill:none;}</style></defs>
                <g id="Слой_2" data-name="Слой 2"><g id="Слой_10" data-name="Слой 10">
                  <rect class="cls-arrow-down-2" width="16" height="16" transform="translate(16 16) rotate(180)"/>
                  <rect class="cls-arrow-down-1" x="6.01" y="4" width="1" height="10" transform="translate(13.01 18) rotate(180)"/>
                  <rect class="cls-arrow-down-1" x="5" y="12" width="1" height="1" transform="translate(11 25) rotate(180)"/>
                  <rect class="cls-arrow-down-1" x="4" y="11" width="1" height="1" transform="translate(9 23) rotate(180)"/>
                  <rect class="cls-arrow-down-1" x="3" y="10" width="1" height="1" transform="translate(7 21) rotate(180)"/>
                  <rect class="cls-arrow-down-1" x="7" y="12" width="1" height="1"/>
                  <rect class="cls-arrow-down-1" x="8" y="11" width="1" height="1"/>
                  <rect class="cls-arrow-down-1" x="9" y="10" width="1" height="1"/>
                </g></g>
              </svg>
            </a>
            <a class='individual-selected-table-rows--cmd'
               href='javascript:;' (click)='remove(idx)'>
              <svg xmlns="http://www.w3.org/2000/svg"
                   width="16" height="16"
                   viewBox="0 0 16 16">
                <defs>
                  <style>.cls-remove-1 {
                    fill: #495660;
                  }

                  .cls-remove-2 {
                    fill: none;
                  }</style>
                </defs>
                <g>
                  <g>
                    <rect class="cls-remove-1" x="7.5" y="7.5" width="1" height="4"
                          transform="translate(-1.5 17.5) rotate(-90)"/>
                    <rect class="cls-remove-2" width="16" height="16"/>
                    <path class="cls-remove-1"
                          d="M10,3V2A1,1,0,0,0,9,1H7A1,1,0,0,0,6,2V3H1V4H15V3ZM7,3V2H9V3Z"/>
                    <polygon class="cls-remove-1"
                             points="12 14 4 14 4 5 3 5 3 15 13 15 13 5 12 5 12 14"/>
                  </g>
                </g>
              </svg>
            </a>
          </div>
        </div>

        <button (click)='save()' class='button-accept'>OK</button>
      </div>
      <div class="modal-bg-gray flex-fill">
        <div class="individual-content-header">
          Доступно для вывода
        </div>
        <div class='individual-available-table-rows'>
          <div *ngFor='let row of tableRows'
               class='flex individual-available-table-rows--item'
               (click)='add(row)'
               [ngClass]="{ 'individual-available-table-rows--item-selected': isRowSelected(row) }">
            <a class='individual-available-table-rows--icon' *ngIf='!isRowSelected(row)'>
              <svg xmlns="http://www.w3.org/2000/svg"
                   width='16' height='16'
                   viewBox="0 0 16 16">
                <defs>
                  <style>.cls-arrow-1, .cls-arrow-2 {
                    fill: none;
                  }

                  .cls-arrow-2 {
                    stroke: #6e95c8;
                    stroke-miterlimit: 10;
                  }

                  .cls-arrow-3 {
                    fill: #6e95c8;
                  }</style>
                </defs>
                <g>
                  <g>
                    <rect class="cls-arrow-1" width="16" height="16"/>
                    <line class="cls-arrow-2" x1="13" y1="8" x2="6" y2="8"/>
                    <polygon class="cls-arrow-3"
                             points="6.5 11.5 3 8 6.5 4.5 6.5 11.5"/>
                  </g>
                </g>
              </svg>
            </a>
            <div
              class='individual-available-table-rows--icon-placeholder'>
            </div>
            <div class='flex-fill individual-available-table-rows--text'>{{ getRowName(row) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

